export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3010";

export function apiFetch(input, init = {}) {
    return fetch(input, { ...init, credentials: "include" });
}
